@if (formGroup.controls.widgetType.value == widgetTypeEnum.RxRefillRequest) {
    <div class="alert alert-info text-center">
        <span class="ml-3">
            Always on for Pharmacy > User Module Access
        </span>
    </div>
}

@if (formGroup.controls.widgetType.value == widgetTypeEnum.SysInvShortcuts) {
    <div class="alert alert-info text-center">
        <span class="ml-3">
            Always on for Inventory > User Module Access
        </span>
    </div>
}


<form 
    pcgSubmitUrl="api/Admin/Widgets/EditWidget" 
    [formGroup]="formGroup"
    (messageSuccess)="onMessageSuccess($event)" 
    (messageError)="onMessageError($event)" 
    class="p-4"
>
    <div class="row">
        <pcg-control-group 
            class="col-md-5" 
            label="Name"
        >
            <input 
                pcgControlRef 
                formControlName="name" 
                class="form-control" 
                type="text" 
                maxlength="501"
            />
        </pcg-control-group>

        <pcg-control-group
            class="col-md-5 text-center" 
            label="Required"
        >
            <input 
                type="checkbox" 
                pcgControlRef 
                formControlName='isRequired' 
            />
        </pcg-control-group>

        <button 
            pcg-svg-history-standalone
            (click)="navigateToAuditHistory()" 
            ngbTooltip="Audit History" 
            class="page-action"
        ></button>
    </div>

    <div class="row">
        <pcg-control-group 
            label="Business Area" 
            class="col-md-4"
        >
            <pcg-select 
                pcgControlRef 
                formControlName="module" 
                dataSource="api/Select/BusinessAreas" 
            />
        </pcg-control-group>

        <pcg-control-group 
            label="Select Permission By" 
            class="col-md-4"
        >
            <p-selectbutton 
                [options]="widgetPermissionTypeOptions" 
                formControlName="widgetPermissionType" 
                optionLabel="name" 
                optionValue="value" 
            />
        </pcg-control-group>

        @if (formGroup.controls.widgetPermissionType.value === widgetPermissionTypeEnum.ByMinimum) {
            <pcg-control-group 
                label="Minimum Required Permission" 
                class="col-md-4"
            >
                <pcg-select 
                    pcgControlRef 
                    formControlName="minPermission" 
                    [items]="permissionRoles()" 
                />
            </pcg-control-group>
        } @else if (formGroup.controls.widgetPermissionType.value === widgetPermissionTypeEnum.ByMaximum) {
            <pcg-control-group 
                label="Maximum Required Permission" 
                class="col-md-4"
            >
                <pcg-select 
                    pcgControlRef 
                    formControlName="maxPermission" 
                    [items]="permissionRoles()" 
                />
            </pcg-control-group>
        } @else if (formGroup.controls.widgetPermissionType.value === widgetPermissionTypeEnum.Custom) {
            <pcg-control-group 
                label="Select All Permissions That Apply" 
                class="col-md-4"
            >
                <pcg-select 
                    pcgControlRef 
                    formControlName="widgetPermissionRoleIds" 
                    [items]="permissionRoles()" 
                    [multiple]="true"
                />
            </pcg-control-group>
        }
    </div>

    <div class="row">
        <pcg-control-group 
            class="col-md-10 text-nowrap" 
            label="Description"
        >
            <textarea 
                pcgControlRef 
                formControlName="description" 
                class="form-control" 
                type="text" 
                maxlength="1000"
            ></textarea>
            <span>Characters left: {{1000 - formGroup.controls.description.value?.length}}</span>
        </pcg-control-group>
    </div>

    <div class="bottom-buttons">
        <button
            class="btn btn-lg btn-cancel"
            (click)="backButton()"  
        >Back</button>
        <button class="btn btn-save btn-lg">Save</button>
    </div>
</form>
